/** Main project script */

// ensure the main object is defined
if (typeof(so) === 'undefined') {
    var so = {};
}

// main code
so.projectname = {
    init: function () {
        this.transitionBanner();
        this.mainNavigation();
        this.loadSwipebox();
        this.makeContainersClickable();
        this.clickNavChildren();
        this.hoverNavChildren();
    },
    transitionBanner: function() {
        setInterval(function() {
            var current = $(".banner-item.opaque");

            if ($(current).next('.banner-item').length > 0) {
                $(current).next().addClass('opaque');
            } else {
                $(".banner-item").first().addClass('opaque');
            }

            $(current).removeClass('opaque');
        }, 4000);
    },
    mainNavigation: function() {
        $("#main-menu-trigger").click(function(e) {
            e.preventDefault();

            $("#navbar-main").toggleClass('show');
            $(this).toggleClass('open');
            $(".main").toggleClass('d-none d-md-block');
            $(".footer-main").toggleClass('d-none d-md-block');
        });
    },
    loadSwipebox: function() {
        $('.swipebox').swipebox({
            loopAtEnd: true,
            hideBarsDelay : 0,
            afterOpen: function() {
                var $selectorClose = $("#swipebox-close");
                var clickAction = "touchend click";

                $selectorClose.unbind(clickAction);

                $selectorClose.bind(clickAction, function(event) {
                    event.preventDefault();
                    event.stopPropagation();

                    $.swipebox.close();
                });
            }
        });
    },
    makeContainersClickable: function() {
        $(".clickable-container[data-link]").click(function() {
            var href = $(this).attr('data-link');
            var openInNewWindow = $(this).attr('data-new-window');

            if (href) {
                if (openInNewWindow) {
                    window.open(href);
                } else {
                    window.location = href;
                }
            }

            return false;
        });
    },
    clickNavChildren: function() {
        $(".nav-item-trigger").click(function() {
            const target = $(this).attr('data-target');

            $(this).find('.expand-more').toggle();
            $(this).find('.expand-less').toggle();

            if ($(this).attr('aria-expanded') === 'true') {
                $(this).attr('aria-expanded', 'false');
            } else {
                $(this).attr('aria-expanded', 'true');
            }

            if (window.innerWidth >= 992) {
                const menus = $('.nav-item-submenu');
                menus.each(function() {
                    if ('#' + $(this).attr('id') !== target) {
                        $(this).removeClass('nav-item-submenu-open');
                    }
                });
            }

            $(target).toggleClass('nav-item-submenu-open');
        });
    },
    hoverNavChildren: function() {
        $("li.nav-item.has-children").mouseover(function() {
            if (window.innerWidth >= 992) {
                const button = $(this).find('.nav-item-trigger');
                const target = button.attr('data-target');
                $(button).find('.expand-less').show();
                $(button).find('.expand-more').hide();
                $(button).attr('aria-expanded', 'true');

                const menus = $('.nav-item-submenu');
                menus.each(function() {
                    if ('#' + $(button).attr('id') !== target) {
                        $(button).removeClass('nav-item-submenu-open');
                    }
                });

                $(target).addClass('nav-item-submenu-open');
            }
        }).mouseout(function() {
            if (window.innerWidth >= 992) {
                const button = $(this).find('.nav-item-trigger');
                const target = button.attr('data-target');
                $(button).find('.expand-less').hide();
                $(button).find('.expand-more').show();
                $(button).attr('aria-expanded', 'false');
                $(target).removeClass('nav-item-submenu-open');
            }
        });
    }
};

$(document).ready(function () {
    so.projectname.init();
});
